import { render, staticRenderFns } from "./CaptiveFormsModalExtraFieldsItem.vue?vue&type=template&id=0ed291f8&scoped=true"
import script from "./CaptiveFormsModalExtraFieldsItem.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsModalExtraFieldsItem.vue?vue&type=script&lang=js"
import style0 from "./CaptiveFormsModalExtraFieldsItem.vue?vue&type=style&index=0&id=0ed291f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed291f8",
  null
  
)

export default component.exports